import { Theme } from '@mui/material'
import { BGVariants } from '../types/heroTextSection'
import { MatchElementType, MatchElementTypes } from '../types/match'
import { getRequiredResult } from './match'

export const getColor = (
  backgroundColor: string | undefined,
  theme: Theme
): string => {
  switch (backgroundColor) {
    case BGVariants.Grey:
      return theme.palette.newColors.greyBackground
    case BGVariants.Black:
      return theme.palette.newColors.blackBackground
    case BGVariants.DarkPrimary:
      return theme.palette.primary.dark
    case BGVariants.MediumPrimary:
      return theme.palette.primary.contrastText
    case BGVariants.LightPaper:
      return theme.palette.background.paper
    case BGVariants.DarkPaper:
      return theme.palette.common.white
    case BGVariants.DarkPaper2:
      return theme.colors.white[400]
    case BGVariants.White:
      return theme.palette.background.default
    case BGVariants.LightPrimary:
      return theme.palette.action.focus
    case BGVariants.DarkSecondary:
      return theme.palette.secondary.dark
    default:
      return theme.palette.background.default
  }
}

export const getTextColor = (backgroundColor: string, theme: Theme): string => {
  switch (backgroundColor) {
    case BGVariants.DarkPrimary:
    case BGVariants.MediumPrimary:
    case BGVariants.Black:
      return theme.palette.background.default
    case BGVariants.LightPaper:
    case BGVariants.DarkPaper:
    case BGVariants.White:
    case BGVariants.LightPrimary:
    case BGVariants.Grey:
      return theme.palette.text.primary
    default:
      return theme.palette.text.primary
  }
}

export const getMatchColor = (
  matchResult: string,
  element: MatchElementType,
  theme: Theme
): string | undefined => {
  switch (element) {
    case MatchElementTypes.chipText:
      return getRequiredResult(
        matchResult,
        theme.colors.green[50],
        theme.colors.amber[50],
        theme.colors.red[60]
      )

    case MatchElementTypes.chipBackground:
      return getRequiredResult(
        matchResult,
        theme.colors.green[10],
        theme.colors.amber[10],
        theme.colors.red[10]
      )

    case MatchElementTypes.resultValue:
    case MatchElementTypes.progressBar:
      return getRequiredResult(
        matchResult,
        theme.colors.green[40],
        theme.colors.amber[40],
        theme.colors.red[60],
        theme.colors.neutral[50]
      )

    case MatchElementTypes.skillTitle:
      return getRequiredResult(
        matchResult,
        theme.colors.amber[40],
        theme.colors.amber[40],
        theme.colors.red[60]
      )
  }
}

export default getColor
